'use client';

import * as DS from '@aurorasolar/ds';
import { ComponentProps, ReactNode } from 'react';

type Props = Omit<ComponentProps<typeof DS.Text>, 'as' | 'text'> & { children: ReactNode };

export const H2 = ({ children, ...props }: Props) => (
  <DS.Text as="h2" text={{ _: 'h2', lg: 'd1' }} {...props}>
    {children}
  </DS.Text>
);
